<template>
<!--
        <pre>{{form}}</pre>

-->
        <ValidationObserver ref="observer" v-slot="{ invalid, validated, passes, validate }">


            <b-message v-if="invalid && validated "  type="is-danger" aria-close-label="Close message">
                This form contains errors
            </b-message>

        <div class=" signup2 columns vh-100 is-vcentered is-mobile">
            <div class="column is-12">
                <div class="columns is-justify-content-center">
                    <div class="column is-6-tablet is-4-desktop">
                        <ul class="steps">
                            <li class="active"><span><img src="img/check.svg" ></span></li>
                            <li class="active"><span>2</span></li>
                            <li><span>3</span></li>
                        </ul>
                    </div>
                </div>
                <div class="columns">
                    <div
                        class="column is-12-tablet is-offset-0-tablet is-6-desktop is-offset-3-desktop is-6-fullhd is-offset-3-fullhd">
                        <!--<h1 class="is-size-4 has-text-weight-bold m-b-5">Create an account</h1>-->
                        <p class="m-b-40"><small>So that Pickafund can work optimally for you, please take two minutes to answer a few questions…</small></p>
                        <div class="columns is-vcentered is-mobile is-tablet">
                            <div class="column is-8 is-9-desktop is-10-fullhd">
                                <p>How did you hear about us?</p>
                            </div>
                            <div class="column is-4 is-3-desktop is-2-fullhd col-field-wrapper">


                                <ValidationProvider name="confirm" rules="required" v-slot="{ errors,valid }">
                                    <b-field
                                        :type="{ 'is-danger': errors[0], 'is-success': valid }"
                                        :message="errors"
                                    >

                                        <b-select v-model="form.how" class="w-100 is-flex is-justify-content-flex-end" placeholder="Select">
                                            <option value="Television">Television</option>
                                            <option value="Radio">Radio</option>
                                            <option value="Newspaper">Newspaper</option>
                                            <option value="Magazine">Magazine</option>
                                            <option value="Word of mouth">Word of mouth</option>
                                            <option value="Twitter">Twitter</option>
                                            <option value="Linkedin">Linkedin</option>
                                            <option value="Facebook">Facebook</option>
                                            <option value="Google">Google</option>
                                            <option value="Other">Other</option>
                                        </b-select>

                                    </b-field>
                                </ValidationProvider>

                            </div>
                        </div>
                        <div class="columns is-vcentered is-mobile is-tablet">
                            <div class="column is-8 is-9-desktop is-10-fullhd">
                                <p>Year of birth</p>
                                <small style="font-size: .65em; color: #999;">*Used to verify your identity for any account related matters</small>
                            </div>
                            <div class="column is-4 is-3-desktop is-2-fullhd col-field-wrapper">


                                <ValidationProvider name="confirm" rules="required" v-slot="{ errors,valid }">
                                    <b-field
                                        :type="{ 'is-danger': errors[0], 'is-success': valid }"
                                        :message="errors"
                                    >

                                <b-select v-model="form.age" class="w-100 is-flex is-justify-content-flex-end" placeholder="Select">
                                    <option value="2020">2020</option>
                                    <option value="2019">2019</option>
                                    <option value="2018">2018</option>
                                    <option value="2017">2017</option>
                                    <option value="2016">2016</option>
                                    <option value="2015">2015</option>
                                    <option value="2014">2014</option>
                                    <option value="2013">2013</option>
                                    <option value="2012">2012</option>
                                    <option value="2011">2011</option>
                                    <option value="2010">2010</option>
                                    <option value="2009">2009</option>
                                    <option value="2008">2008</option>
                                    <option value="2007">2007</option>
                                    <option value="2006">2006</option>
                                    <option value="2005">2005</option>
                                    <option value="2004">2004</option>
                                    <option value="2003">2003</option>
                                    <option value="2002">2002</option>
                                    <option value="2001">2001</option>
                                    <option value="2000">2000</option>
                                    <option value="1999">1999</option>
                                    <option value="1998">1998</option>
                                    <option value="1997">1997</option>
                                    <option value="1996">1996</option>
                                    <option value="1995">1995</option>
                                    <option value="1994">1994</option>
                                    <option value="1993">1993</option>
                                    <option value="1992">1992</option>
                                    <option value="1991">1991</option>
                                    <option value="1990">1990</option>
                                    <option value="1989">1989</option>
                                    <option value="1988">1988</option>
                                    <option value="1987">1987</option>
                                    <option value="1986">1986</option>
                                    <option value="1985">1985</option>
                                    <option value="1984">1984</option>
                                    <option value="1983">1983</option>
                                    <option value="1982">1982</option>
                                    <option value="1981">1981</option>
                                    <option value="1980">1980</option>
                                    <option value="1979">1979</option>
                                    <option value="1978">1978</option>
                                    <option value="1977">1977</option>
                                    <option value="1976">1976</option>
                                    <option value="1975">1975</option>
                                    <option value="1974">1974</option>
                                    <option value="1973">1973</option>
                                    <option value="1972">1972</option>
                                    <option value="1971">1971</option>
                                    <option value="1970">1970</option>
                                    <option value="1969">1969</option>
                                    <option value="1968">1968</option>
                                    <option value="1967">1967</option>
                                    <option value="1966">1966</option>
                                    <option value="1965">1965</option>
                                    <option value="1964">1964</option>
                                    <option value="1963">1963</option>
                                    <option value="1962">1962</option>
                                    <option value="1961">1961</option>
                                    <option value="1960">1960</option>
                                    <option value="1959">1959</option>
                                    <option value="1958">1958</option>
                                    <option value="1957">1957</option>
                                    <option value="1956">1956</option>
                                    <option value="1955">1955</option>
                                    <option value="1954">1954</option>
                                    <option value="1953">1953</option>
                                    <option value="1952">1952</option>
                                    <option value="1951">1951</option>
                                    <option value="1950">1950</option>
                                    <option value="1949">1949</option>
                                    <option value="1948">1948</option>
                                    <option value="1947">1947</option>
                                    <option value="1946">1946</option>
                                    <option value="1945">1945</option>
                                    <option value="1944">1944</option>
                                    <option value="1943">1943</option>
                                    <option value="1942">1942</option>
                                    <option value="1941">1941</option>
                                    <option value="1940">1940</option>
                                    <option value="1939">1939</option>
                                    <option value="1938">1938</option>
                                    <option value="1937">1937</option>
                                    <option value="1936">1936</option>
                                    <option value="1935">1935</option>
                                    <option value="1934">1934</option>
                                    <option value="1933">1933</option>
                                    <option value="1932">1932</option>
                                    <option value="1931">1931</option>
                                    <option value="1930">1930</option>
                                    <option value="1929">1929</option>
                                    <option value="1928">1928</option>
                                    <option value="1927">1927</option>
                                    <option value="1926">1926</option>
                                    <option value="1925">1925</option>
                                    <option value="1924">1924</option>
                                    <option value="1923">1923</option>
                                    <option value="1922">1922</option>
                                    <option value="1921">1921</option>
                                    <option value="1920">1920</option>
                                    <option value="1919">1919</option>
                                    <option value="1918">1918</option>
                                    <option value="1917">1917</option>
                                    <option value="1916">1916</option>
                                    <option value="1915">1915</option>
                                    <option value="1914">1914</option>
                                    <option value="1913">1913</option>
                                    <option value="1912">1912</option>
                                    <option value="1911">1911</option>
                                    <option value="1910">1910</option>
                                    <option value="1909">1909</option>
                                    <option value="1908">1908</option>
                                    <option value="1907">1907</option>
                                    <option value="1906">1906</option>
                                    <option value="1905">1905</option>

                                </b-select>

                                    </b-field>
                                </ValidationProvider>
                                <!--
                                <b-field>
                                    <b-input
                                        size="is-medium" v-model="form.age">
                                    </b-input>

                                </b-field>
                                -->
                            </div>
                        </div>
                        <div class="columns is-vcentered is-mobile mb-5">
                            <div class="column is-12">
                                <p class="m-b-25">Do you have any of the following?</p>
                                <div class="columns is-mobile" >
                                    <div class="column is-8 is-9-desktop is-10-fullhd p-l-40-mobile p-l-50-tablet">
                                        <p class="has-bullet">Workplace Pension</p>
                                    </div>
                                    <div class="column is-4 is-3-desktop is-2-fullhd col-field-wrapper">
                                        <b-field class="field-radio">
                                            <b-radio-button v-model="form.workplacepension"
                                                            :native-value="true" >
                                                <span>Yes</span>
                                            </b-radio-button>
                                            <b-radio-button v-model="form.workplacepension"
                                                            :native-value="false">
                                                <span>No</span>
                                            </b-radio-button>
                                        </b-field>
                                    </div>
                                </div>
                                <div class="columns is-vcentered is-mobile">
                                    <div class="column is-8 is-9-desktop is-10-fullhd p-l-40-mobile p-l-50-tablet">
                                        <p class="has-bullet">Investment Platform Account</p>
                                    </div>
                                    <div class="column is-4 is-3-desktop is-2-fullhd col-field-wrapper">
                                        <b-field class="field-radio">
                                            <b-radio-button v-model="form.investmentplatform"
                                                            :native-value="true" >
                                                <span>Yes</span>
                                            </b-radio-button>
                                            <b-radio-button v-model="form.investmentplatform"
                                                            :native-value="false">
                                                <span>No</span>
                                            </b-radio-button>
                                        </b-field>
                                    </div>
                                </div>
                                <div class="columns is-vcentered is-mobile">
                                    <div class="column is-8 is-9-desktop is-10-fullhd p-l-40-mobile p-l-50-tablet">
                                        <p class="has-bullet">Finance related subscription (eg. paper, magazine, website)</p>
                                    </div>
                                    <div class="column is-4 is-3-desktop is-2-fullhd col-field-wrapper">
                                        <b-field class="field-radio">
                                            <b-radio-button v-model="form.payingsubscriber"
                                                            :native-value="true" >
                                                <span>Yes</span>
                                            </b-radio-button>
                                            <b-radio-button v-model="form.payingsubscriber"
                                                            :native-value="false">
                                                <span>No</span>
                                            </b-radio-button>
                                        </b-field>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="columns is-vcentered is-mobile">
                            <div class="column is-6 is-9-desktop is-10-fullhd">
                                <p>What is your risk tolerance?</p>
                            </div>
                            <div class="column is-6 is-3-desktop is-2-fullhd col-field-wrapper">
                                <div class="field">
                                    <b-field class="field-radio">
                                    <b-radio-button v-model="form.risktolerance"
                                                    native-value="high" >
                                        <span>High</span>
                                    </b-radio-button>
                                    <b-radio-button v-model="form.risktolerance"
                                                    native-value="medium">
                                        <span>Medium</span>
                                    </b-radio-button>
                                    <b-radio-button v-model="form.risktolerance"
                                                    native-value="low">
                                        <span>Low</span>
                                    </b-radio-button>
                                    </b-field>

                                    <!--
                                    <b-select v-model="form.risktolerance" placeholder="Select">
                                        <option value="high">High</option>
                                        <option value="medium">Medium</option>
                                        <option value="low">Low</option>
                                    </b-select>
                                    -->


                                </div>
                            </div>
                        </div>


                    </div>
                </div>

                <div class="columns">
                    <div class="column is-12-tablet is-offset-0-tablet is-10-fullhd is-offset-1-fullhd">
                        <div class="columns is-vcentered is-desktop">
                            <div class="column is-6 is-offset-3">
                                <div class="is-flex buttons-wrapper">
                                    <a @click="save" class="button m-b-15-mobile btn-clear" style="height: 45px;">Come back later</a>
                                    <a @click="saveAndMove" class="button is-primary">Next</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </ValidationObserver>
</template>

<style>
.signup2 p.help.is-danger{
    text-align: right !important;
}
</style>

<script>

import {ValidationProvider, ValidationObserver, setInteractionMode} from 'vee-validate';

setInteractionMode('eager')

export default {
    name: 'SignUp2',
    props: {
        profile: Object,
        prevRoute:String,
    },
    components: {
        ValidationProvider,
        ValidationObserver
    },
    data() {
        return {
            form: {}
        }
    },
    methods: {
        saveAndMove() {
            this.$refs.observer.validate().then(async success => {
                if (!success) {
                    const el = document.querySelector(".help.is-danger:first-of-type");
                    el.scrollIntoView(true);
                    window.scrollBy(0, -150);
                    return;
                }
                this.$store.commit("auth/SET_PROFILE",1)
                this.form.completedstage1 = true
                this.$emit("update", this.form)
                this.$toast.success("The first stage of you profile has been completed")
                //this.$router.push("/")
            })

        },
        save() {
            this.$refs.observer.validate().then(async success => {
                if (!success) {
                    const el = document.querySelector(".help.is-danger:first-of-type");
                    el.scrollIntoView(true);
                    window.scrollBy(0, -150);
                    return;
                }
                this.$store.commit("auth/SET_PROFILE",1)
                this.form.completedstage1 = true
                this.$emit("update", this.form)
                this.$toast.success("You profile has been saved")
                this.$router.push(this.prevRoute)
                if(this.$store.state.auth.userProfile.is_new_user) this.$router.push("/")
                else this.$router.go(-1);
            })
        }
    },
    watch:{
        profile:{
            immediate: true,
            handler: function(newProfile) {
                this.form = newProfile
            }
        },
        '$store.state.auth.isValidateField': function () {
            this.$refs.observer.validate().then(async success => {
                if (!success) {
                    const el = document.querySelector(".help.is-danger:first-of-type");
                    el.scrollIntoView(true);
                    window.scrollBy(0, -150);
                    return;
                }
            })
        }
    }
}
</script>


